type Props = {
  handleSubmit: $TSFixMeFunction;
  setStatus: $TSFixMeFunction;
  children: React.ReactNode;
};

function Form({ handleSubmit, setStatus, children }: Props) {
  const beforeHandleSubmit = (event: $TSFixMe) => {
    setStatus("submitted");
    handleSubmit(event);
  };

  return (
    <form onSubmit={beforeHandleSubmit} noValidate>
      {children}
    </form>
  );
}

export default Form;
